module.exports = __webpack_public_path__ + "img/speaker-4-3.336d11c9.jpg";